import { useTranslation } from 'react-i18next';
import { IProduct } from "../types.ts";

export default function ProductCard({product}: { product: IProduct }) {
	const { t } = useTranslation('products');

	const computedPrice = () => {
		switch (product.price_option) {
			case "price_on_request":
				return t('price.onRequest');
			case "to_give":
				return t('price.toGive');
			case "contact_us":
				return t('price.contactUs');
			case "choose_price":
				return product.price;
		}
	};

	return (
		<a href={product.url}
		   className="product-card tw-no-underline tw-transition tw-flex tw-flex-col tw-bg-white tw-shadow hover:tw-shadow-md tw-cursor-pointer">
			<img className={'tw-aspect-square tw-object-contain'} src={product.image} alt={product.title}/>
			<div className="tw-p-4 [&>p:not(:first-child)]:tw-m-0 [&>p:not(:first-child)]:tw-text-base">
				<p className="tw-font-bold tw-uppercase tw-mt-0 tw-mb-1 tw-text-xs">{product.vendor}</p>
				<p className="product-title">{product.title}</p>
				<p>{computedPrice()}</p>
			</div>
		</a>
	)
}